import TextField from '@sdk/components/forms/TextField';
import styled from 'styled-components';

type CustomTextFieldProps = { width: number };

export const CustomTextField = styled(TextField)<CustomTextFieldProps>`
  max-width: ${({ width }) => width}px;
`;
